export default function InfoRow({ data, label, about }) {
  return (
    <div className="flex items-baseline gap-2 py-0.5">
      <label className="text-slate-400 text-sm font-medium min-w-[120px] shrink-0" htmlFor={about}>
        {label}:
      </label>
      <span about={about} className="text-white text-sm">
        {data ?? "—"}
      </span>
    </div>
  );
}

